export default {
  SET_DOMAIN: '@@app/SET_DOMAIN',

  SET_INSTRUCTOR: '@@app/SET_INSTRUCTOR',
  SIDEBAR_HIDE:   '@@app/SIDEBAR_HIDE',

  SIDEBAR_TOGGLE: '@@app/SIDEBAR_TOGGLE'
};